<div class="py-5 px-3 px-md-5">
  <div>
    <h3>
      {{ "homepage.direct-channel.areas.title" | translate }}
    </h3>
    <h4 class="whitespace-preline">
      {{ "homepage.direct-channel.areas.subtitle" | translate }}
    </h4>
  </div>

  <div class="container-fluid pt-4">
    <div class="row gx-0 gx-sm-3 mb-4">
      <div class="col-12 col-sm-6 pointer mb-4 mb-sm-0" (click)="goToESGArea()">
        <div class="esg">
          <div class="background">
            <div class="title">
              {{ "thematic-area.area-enum.esg" | translate }}
            </div>
            <!-- <div class="sub-title">{{'homepage.direct-channel.areas.esg' | translate}}</div> -->
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 pointer" (click)="goToTransDigitaleArea()">
        <div class="trans-digitale">
          <div class="background">
            <div class="title">
              {{ "thematic-area.area-enum.digital" | translate }}
            </div>
            <!-- <div class="sub-title">{{'homepage.direct-channel.areas.digital' | translate}}</div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="row gx-0 gx-sm-3">
      <div class="col-12 col-sm-6 pointer mb-4 mb-sm-0" (click)="goToCybersecurityArea()">
        <div class="cybersecurity">
          <div class="background">
            <div class="title">
              {{ "thematic-area.area-enum.cyber" | translate }}
            </div>
            <!-- <div class="sub-title">{{'homepage.direct-channel.areas.cyber' | translate}}</div> -->
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 pointer">
        <div class="trans-energetica" (click)="goToTransEnergeticaArea()">
          <div class="background">
            <div class="title">
              {{ "thematic-area.area-enum.energy" | translate }}
            </div>
            <!-- <div class="sub-title">{{'homepage.direct-channel.areas.energy' | translate}}</div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
